import { Box, BoxProps, LinearProgress, Stack } from "@mui/material";

import { useOnboardingContext } from "@/common/contexts/onboarding";

import AppTypography from "../../Text/AppTypography";
import AppTooltip from "../../Tooltip/AppTooltip";

interface Props {
  withPercentageText?: boolean;
  withTooltip?: boolean;
  sx?: BoxProps["sx"];
}

export function OnboardingProgressIndicator({
  withPercentageText = true,
  withTooltip = true,
  sx,
}: Props) {
  const onboardingContext = useOnboardingContext();

  if (!onboardingContext.progress) {
    return null;
  }

  return (
    <AppTooltip
      isEnabled={withTooltip}
      title='Your onboarding progress. Keep going!'
      isDefaultEnterDelays
    >
      <Box sx={{ width: "100%", ...sx }}>
        <Stack direction='row' sx={{ gap: 2, alignItems: "center" }}>
          <Stack direction='row' sx={{ gap: 1, alignItems: "center" }}>
            <AppTypography component='span' variant='h3'>
              {onboardingContext.progress.completedStepCount}
            </AppTypography>
            <AppTypography component='span' variant='h6' color='text.secondary'>
              /
            </AppTypography>
            <AppTypography component='span' variant='h6' color='text.secondary'>
              {onboardingContext.progress.totalStepCount}
            </AppTypography>
          </Stack>

          <LinearProgress
            sx={{ flex: 1, height: 8 }}
            variant='determinate'
            color='primary'
            aria-label='Onboarding progress'
            value={onboardingContext.progress.progressPct100}
          />
        </Stack>

        {withPercentageText && (
          <Box sx={{ mt: 0.5 }}>
            <AppTypography component='span' variant='body1' color='text.secondary'>
              {onboardingContext.progress.progressPct100}% completed -
            </AppTypography>{" "}
            <AppTypography component='span' variant='body1' color='primary'>
              Nice work!
            </AppTypography>
          </Box>
        )}
      </Box>
    </AppTooltip>
  );
}
